import request from '@/utils/request'

// 友情链接
export function friendshipLinkList() {
  return request({
    method: 'get',
    url: '/reception/friendshipLink/list',
  })
}